import { render, staticRenderFns } from "./distributorBill.vue?vue&type=template&id=12328430&scoped=true&"
import script from "./distributorBill.vue?vue&type=script&lang=js&"
export * from "./distributorBill.vue?vue&type=script&lang=js&"
import style0 from "./distributorBill.vue?vue&type=style&index=0&id=12328430&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12328430",
  null
  
)

export default component.exports